(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initCountUp(el) {
    const target = parseInt(el.dataset.countTo, 10);
    if (Number.isNaN(target)) return;
    const suffix = el.dataset.countSuffix || '';
    const duration = parseInt(el.dataset.countDuration, 10) || 1400;

    function render(value) {
      el.textContent = value + suffix;
    }

    if (prefersReducedMotion()) {
      render(target);
      return;
    }

    const observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      const start = performance.now();
      function tick(now) {
        const progress = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        render(Math.round(eased * target));
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }, { threshold: 0.5 });

    observer.observe(el);
  }

  function initPromiseCarousel(root) {
    const grid = root.querySelector('[data-dvhh-promise-grid]');
    const dots = root.querySelectorAll('[data-dvhh-promise-dot]');
    if (!grid || !dots.length) return;

    function setPage(page) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === page);
        dot.setAttribute('aria-selected', i === page ? 'true' : 'false');
      });
    }

    grid.addEventListener('scroll', function () {
      const width = grid.clientWidth || 1;
      setPage(Math.round(grid.scrollLeft / width));
    }, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const page = parseInt(dot.dataset.dvhhPromiseDot, 10) || 0;
        grid.scrollTo({ left: page * grid.clientWidth, behavior: 'smooth' });
      });
    });
  }

  function initScrollLinks() {
    document.querySelectorAll('[data-dvhh-scroll]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        const href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        const target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();

        // scroll-margin-top van het doel meenemen. Deze scroll gebeurt met
        // window.scrollTo op een zelf berekende positie en niet met
        // scrollIntoView, en dan past de browser die eigenschap niet toe. Zonder
        // dit landt de sectie precies onder een sticky header.
        // Doelen zonder scroll-margin-top geven 0px, dus dit verandert niets
        // voor de bestaande scroll-links.
        const offset = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      });
    });
  }

  async function waitForPBCart() {
    for (let i = 0; i < 80; i++) {
      if (window.PBCart && typeof window.PBCart.addLine === 'function') {
        return window.PBCart;
      }
      await new Promise(function (r) { setTimeout(r, 50); });
    }
    throw new Error('PBCart.addLine not available');
  }

  function bindAddToCart(root) {
    (root || document).querySelectorAll('[data-dvhh-add-to-cart]').forEach(function (btn) {
      if (btn.dataset.dvhhAtcBound === 'true') return;
      btn.dataset.dvhhAtcBound = 'true';

      btn.addEventListener('click', async function (event) {
        event.preventDefault();
        event.stopPropagation();

        const variantId = btn.getAttribute('data-variant-id');
        const qty = parseInt(btn.getAttribute('data-quantity') || '1', 10) || 1;
        const addedLabel = btn.getAttribute('data-added-label') || '✓ TOEGEVOEGD';

        if (!variantId || btn.disabled) return;

        const originalLabel = btn.textContent;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');

        try {
          const pb = await waitForPBCart();
          await pb.addLine(String(variantId), qty);
          document.dispatchEvent(new CustomEvent('cart:open'));
          btn.textContent = addedLabel;
          setTimeout(function () {
            btn.textContent = originalLabel;
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }, 1200);
        } catch (err) {
          console.error('[DVHH] addLine failed', err);
          btn.textContent = originalLabel;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
      });
    });
  }

  function initMarquee(scope) {
    (scope || document).querySelectorAll('[data-dvhh-marquee]').forEach(function (wrapper) {
      if (wrapper.dataset.dvhhMarqueeInit === 'true') return;

      const band = wrapper.closest('.dvhh-marquee-band');
      const track = wrapper.querySelector('[data-dvhh-marquee-track]');
      if (!band || !track) return;

      wrapper.dataset.dvhhMarqueeInit = 'true';

      let resizeTimer;

      function rebuild() {
        wrapper.querySelectorAll('[data-dvhh-marquee-track]').forEach(function (node, index) {
          if (index > 0) node.remove();
        });

        const viewWidth = band.clientWidth;
        const trackWidth = track.offsetWidth;
        if (trackWidth === 0) return;

        const minWidth = viewWidth + trackWidth;
        while (wrapper.scrollWidth < minWidth) {
          wrapper.appendChild(track.cloneNode(true));
        }

        const animate = !band.classList.contains('no-anim') && !prefersReducedMotion();
        if (animate) {
          wrapper.style.setProperty('--marquee-shift', trackWidth + 'px');
        } else {
          wrapper.style.removeProperty('--marquee-shift');
        }
      }

      function scheduleRebuild() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(rebuild, 100);
      }

      rebuild();

      window.addEventListener('resize', scheduleRebuild);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(rebuild);
      }

      if (typeof ResizeObserver !== 'undefined') {
        var observer = new ResizeObserver(scheduleRebuild);
        observer.observe(band);
        observer.observe(track);
      }
    });
  }

  function initMobileFooterFinaleTone() {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    if (document.documentElement.dataset.dvhhFooterToneInit === 'true') return;
    document.documentElement.dataset.dvhhFooterToneInit = 'true';

    const finale = document.querySelector('.dvhh.finale');
    const mobileFooter = document.querySelector('.mobile-footer');
    if (!finale || !mobileFooter) return;

    const safeArea = mobileFooter.nextElementSibling;
    const hasSafeArea = safeArea && safeArea.classList.contains('footer-safe-area');

    function update() {
      const finaleBottom = finale.getBoundingClientRect().bottom;
      const active = finaleBottom <= window.innerHeight;
      mobileFooter.classList.toggle('mobile-footer--finale-tone', active);
      if (hasSafeArea) safeArea.classList.toggle('footer-safe-area--finale-tone', active);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-dvhh-count]').forEach(initCountUp);
    scope.querySelectorAll('[data-dvhh-promise]').forEach(initPromiseCarousel);
    initMarquee(scope);
    initScrollLinks();
    bindAddToCart(scope);
    initMobileFooterFinaleTone();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
